import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TranslatePipe} from '@ngx-translate/core';
import {FormControl, FormGroup} from '@ng-stack/forms';
import {ALLOWED_PROJECT_LINK, FormUtil} from '../../utils';
import {ProjectLink} from '../../models/project-analysis';

export interface ProjectLinkModalData {
    title: string;
    saveText: string;
    data?: ProjectLink;
}

const TITLE_MAX_LENGTH = 255;
const LINK_MAX_LENGTH = 1024;

@Component({
    selector: 'app-create-update-project-link-modal',
    templateUrl: './create-update-project-link-modal.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, TranslatePipe, VwuiAngularModule]
})
export class CreateUpdateProjectLinkModalComponent {
    public readonly modalRef = inject(VwuiModalRef);
    private readonly modalConfig = inject<VwuiModalConfig<ProjectLinkModalData>>(VwuiModalConfig);

    public readonly title = this.modalConfig.data.title;
    public readonly saveText = this.modalConfig.data.saveText;
    private readonly data = this.modalConfig.data.data;

    public readonly form = new FormGroup({
        title: new FormControl(this.data?.title ?? '', [Validators.required, Validators.maxLength(TITLE_MAX_LENGTH)]),
        link: new FormControl(this.data?.link ?? '', [
            Validators.required,
            Validators.maxLength(LINK_MAX_LENGTH),
            Validators.pattern(ALLOWED_PROJECT_LINK)
        ])
    });

    public get linkInvalid(): boolean {
        const control = this.form.controls.link;

        return control.touched && control.invalid;
    }

    public submit(): void {
        FormUtil.validate(this.form);
        if (this.form.invalid) {
            return;
        }

        this.modalRef.close({
            ...this.data,
            title: this.form.value.title.trim(),
            link: this.form.value.link.trim()
        });
    }
}
